import { RootState } from 'store/root-reducer';

import { Group } from './types';

export const getGroups = (state: RootState): Group[] | null => state.admin.groups.entities;
export const isGroupsLoading = (state: RootState): boolean => state.admin.groups.isLoading;
export const isUpdateGroupLoading = (state: RootState): boolean => state.admin.groups.isUpdatedGroupLoading;
export const isCreateGroupLoading = (state: RootState): boolean => state.admin.groups.isCreateGroupLoading;
